/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';

export const sendSignUpOTP = async (data: {
  businessName?: string;
  businessWebsite?: string;
  email?: string;
  firstName: string;
  lastName: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email || data?.businessWebsite) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.sendSignUpOTP}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export const resendSignUpOTP = async (data: {
  email?: string;
  firstName: string;
  lastName: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.resendSignUpOTP}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};

export const verifyAccount = async (data: {
  businessName: string;
  businessWebsite: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  subscribe: boolean;
  otp: string;
}): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (data?.email) {
    try {
      const response = await axios.request({
        method: CRUDMethods.POST,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.verifyAccount}`,
        params: {},
        data
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
};
